var _circle, _circle2, _circle3, _path, _path2, _circle4, _circle5, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBall50 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_25164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "url(#paint0_radial_51_25164)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_25164)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "#9B51E0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 -6L48.3956 18.5625L75.8954 23.7123L56.6746 44.0425L60.2748 71.7877L35 59.79L9.72523 71.7877L13.3254 44.0425L-5.89543 23.7123L21.6044 18.5625L35 -6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9136 14.3676L51.1411 14.7845L51.6069 14.8715L84.2749 20.9886L61.4419 45.141L61.1157 45.4857L61.1772 45.9564L65.4536 78.9154L35.4292 64.6635L35.0005 64.4603L34.5708 64.6635L4.54541 78.9154L8.82275 45.9564L8.88428 45.4857L8.55811 45.141L-14.2759 20.9886L18.3931 14.8715L18.8599 14.7845L19.0864 14.3676L34.9995 -14.8121L50.9136 14.3676Z",
    stroke: "white",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "url(#paint1_radial_51_25164)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3514 46.9349C19.2322 46.9349 16.1328 44.3231 15.8194 40.5969H20.6252C20.9734 42.0943 22.2619 43.2784 24.2818 43.2784C26.824 43.2784 28.1125 41.3282 28.1125 39.0298C28.1125 36.6617 26.7195 34.9205 24.4211 34.9205C23.1674 34.9205 22.053 35.4428 21.252 36.209H16.9338L18.0133 23.8114H31.4904V27.5725H21.844L21.3913 32.5872H22.0182C23.2022 31.8907 24.2818 31.5773 25.814 31.5773C30.0626 31.5773 33.162 34.3981 33.162 39.0298C33.162 43.8355 29.8537 46.9349 24.3514 46.9349ZM44.9629 46.9349C39.1472 46.9349 35.3165 42.1988 35.3165 35.1294C35.3165 28.06 39.1472 23.3239 44.9629 23.3239C50.7438 23.3239 54.5745 28.06 54.5745 35.1294C54.5745 42.1988 50.7438 46.9349 44.9629 46.9349ZM40.4357 35.1294C40.4357 40.2138 42.2118 43.1042 44.9629 43.1042C47.7141 43.1042 49.4901 40.2138 49.4901 35.1294C49.4901 30.045 47.7141 27.1546 44.9629 27.1546C42.2118 27.1546 40.4357 30.045 40.4357 35.1294Z",
    fill: "#082037"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_51_25164",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2067 29.3832) rotate(49.2364) scale(41.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_51_25164",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2067 29.3832) rotate(49.2364) scale(41.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBall50);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ball-50.ade3dcdee51760501477d0be5dfad663.svg";